import SaporeForm from "../forms/SaporeForm";
import FileField from "../forms/fields/FileField";
import OptionField from "../forms/fields/OptionField";

export default class BudgetForm extends SaporeForm {
    static newFor(feature, initialData = {}) {
        return new BudgetForm(initialData, feature);
    }

    constructor(initialData = {}, feature = null) {
        super({}, null, feature);
        const fields = {
            year: new OptionField(feature.yearOptions(), false, feature, initialData.year, false),
            salesBudgetFile: new FileField(0, 1, true, initialData.salesBudgetFile ?? null, feature),
            inflationCategoryGroupsFile: new FileField(0, 1, true, initialData.inflationCategoryGroupsFile ?? null, feature),
        };
        this.setFields(fields);
    }

    isOptional(fieldName) {
        return this.getFieldByName(fieldName).isOptional;
    }

    isReadonly() {
        return false;
    }
}
